import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Mail } from "lucide-react";

export function NewsletterSignup({ source = "footer" }: { source?: string }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = email.trim().toLowerCase();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) {
      return toast.error("Please enter a valid email");
    }
    setLoading(true);
    const { error } = await supabase
      .from("newsletter_subscribers")
      .insert({ email: trimmed, source });
    setLoading(false);
    if (error) {
      if (error.code === "23505") {
        toast.success("You're already subscribed — thank you!");
      } else {
        toast.error(error.message);
      }
      return;
    }
    toast.success("Thanks for subscribing!");
    setEmail("");
  };

  return (
    <form onSubmit={submit} className="space-y-3">
      <div className="flex items-center gap-2 text-sm text-background/80">
        <Mail className="h-4 w-4" />
        <span>Subscribe to our newsletter</span>
      </div>
      <div className="flex gap-2">
        <Input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@email.com"
          className="bg-background/10 border-background/20 text-background placeholder:text-background/70"
        />
        <Button type="submit" disabled={loading} variant="secondary">
          {loading ? "..." : "Join"}
        </Button>
      </div>
      <p className="text-xs text-background/80">
        Monthly stories from the field. No spam — unsubscribe anytime.
      </p>
    </form>
  );
}
